import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { CallDirection } from '@repo/types'

/**
 * Hovory kontaktu alebo obchodu z `GET /call-logs` pre históriu komunikácie.
 *
 * Všetky kľúče sú pod prefixom `['call-logs']` — ten invaliduje AI asistent (poznámka hovoru)
 * aj poznámka kontaktu (`hooks/api/notes.ts`). API filtruje `contactId` a `dealId`: história osoby
 * alebo obchodu ukazuje hovory všetkých kolegov (globálny zoznam bez filtra je osobný), tiper vidí
 * len hovory svojich osôb a `calledAt` má redigovaný.
 */
export type CallLogsRef = { contactId: string } | { dealId: number }

export interface CallLogItem {
  id: string
  phone: string
  direction: CallDirection
  duration: number | null
  /** Tiperovi `null` — čas hovoru je osobný údaj. */
  calledAt: string | null
  note: string | null
  /** Hovor posunul kontakt do stavu „Kontaktovaný". */
  autoAdvanced: boolean
  user: { id: string; firstName: string; lastName: string } | null
}

export const callLogKeys = {
  /** Prefix všetkých zoznamov hovorov — na invalidáciu. */
  all: ['call-logs'] as const,
  list: (ref: CallLogsRef | undefined) => ['call-logs', ref] as const,
}

/** Bez `ref` sa nenačítava. */
export function useCallLogs(ref: CallLogsRef | undefined) {
  return useQuery({
    queryKey: callLogKeys.list(ref),
    queryFn: async () => (await api.get<CallLogItem[]>('/call-logs', { params: ref })).data,
    enabled: !!ref,
  })
}
